import { v4 } from 'uuid';
import { Cookies } from '@grandvisionhq/utils';

function generateIdentifierName(key) {
    return "__prid_" + key;
}
function generateRandomId(key) {
    return { name: generateIdentifierName(key), value: v4() };
}
/**
 * storage is where the random id persists e.g. cookies
 */
function getPersistentRandomId(key, storage) {
    var identifier = generateIdentifierName(key);
    // check document.cookie
    if (!storage && typeof document !== 'undefined') {
        storage = document.cookie;
    }
    if (!storage) {
        return null;
    }
    // raw cookie
    if (typeof storage === 'string') {
        return Cookies.parseCookieString(storage)[identifier] || null;
    }
    // cookie object
    return (storage === null || storage === void 0 ? void 0 : storage[identifier]) || null;
}
// uuid v4 regex
var PersistentRandomIdPattern = /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;

export { PersistentRandomIdPattern, generateRandomId, getPersistentRandomId };
//# sourceMappingURL=index.es.js.map
